import React from "react";
import FormPageTopBar from "../Components/FormPageTopBar";
import styled from "styled-components";

const FormsPage = ({ form }) => {
  const ListViewCompnent = styled.div`
    width: 100%;
  `;
  return (
    <ListViewCompnent>
      <FormPageTopBar />
    </ListViewCompnent>
  );
};

export default FormsPage;
